// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"396":"74f48ba9","499":"2c402509","573":"977a036b","801":"f5776ea7","867":"f5776ea7"}[chunkId] + ".chunk.css";
};